import {
  Box,
  Button,
  FormLabel,
  HStack,
  Input,
  Switch,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useState } from "react";
import { useSelector } from "react-redux";
import Select from "react-select";
import MainInput from "../../../../components/Form/input";
import {
  bookmarkOptions,
  colourStyles,
  difficultyOptions,
  randomOptions,
  subTypeOptions,
  typeOptions,
} from "./options";

const StepOneForm = ({
  data,
  register,
  errors,
  isFormOne,
  watchTimer,
  setValue,
  watchType,
  watchQuestionWay,
  watchTotalQustions,
  watchBucket,
  watchTags,
  watchSubType,
  errorslist,
}) => {
  const [fieldsCount, setFieldsCount] = useState(1);
  const [tagsFieldsCount, setTagsFieldsCount] = useState(1);
  const [videosOptions, setVideosOptions] = useState([]);

  const totalSelectedQuestions = watchBucket?.reduce((accumulator, value) => {
    return Number(accumulator) + Number(value?.no_of_questions);
  }, 0);

  const totalSelectedQuestionsFromTags = watchTags?.reduce((accumulator, value) => {
    return Number(accumulator) + Number(value?.no_of_questions);
  }, 0);

  const { chapters } = useSelector((state) => state.superadminChapters);
  const { videos } = useSelector((state) => state.superadminVideos);
  const { payments } = useSelector((state) => state.superadminPayment);
  const { buckets } = useSelector((state) => state.superadminBuckets);
  const { groups } = useSelector((state) => state.superadminGroups);
  const { tags } = useSelector((state) => state.superadminTags);

  const paymentSubjectsOptions = payments?.map((data) => {
    return { value: data.id, label: data.name };
  });
  const chaptersOptions = chapters?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const bucketsOptions = buckets?.map((data) => {
    return { value: data.id, label: data.name };
  });
  const groupsOptions = groups?.map((data) => {
    return { value: data.id, label: data.name };
  });
  const tagsOptions = tags?.map((data) => {
    return { value: data.id, label: data.name };
  });
  return (
    <VStack
      dir="rtl"
      w="100%"
      flexWrap="wrap"
      justifyContent="space-between"
      display={isFormOne ? "flex" : "none"}
      spacing="30px"
    >
      <Box w="100%">
        <MainInput
          label=" عنوان الاختبار"
          defaultValues={data.name}
          error={errors?.name?.message}
          placeholder=" ادخل عنوان الاختبار "
          register={register}
          name="name"
        />
      </Box>

      <HStack w="100%" alignItems="flex-start">
        <VStack w="50%" gap={4}>
          <HStack
            direction="row"
            w="100%"
            role="group"
            aria-labelledby="my-radio-group"
            spacing="20px"
          >
            <Switch
              id="is_timed"
              defaultChecked={data?.is_timed}
              {...register("is_timed")}
            />
            <FormLabel htmlFor="is_timed">إضافة مؤقت للاختبار </FormLabel>

            <Text color="red">{errors?.is_timed?.message}</Text>
          </HStack>
          <HStack w="100%">
            <Switch
              id="auto_publish_result"
              defaultChecked={data?.auto_publish_result}
              {...register("auto_publish_result")}
            />
            <FormLabel htmlFor="auto_publish_result">
              نشر نتيجة الاختبار{" "}
            </FormLabel>
          </HStack>
          {console.log(errors)}
          <HStack w="100%">
            <Switch
              defaultChecked={data?.published}
              id="published"
              {...register("published")}
            />
            <FormLabel htmlFor="published"> نشر الاختبار </FormLabel>
          </HStack>
          <HStack w="100%">
            <Switch
              defaultChecked={data?.enable}
              id="enable"
              {...register("enable")}
            />
            <FormLabel htmlFor="enable"> تفعيل الاختبار </FormLabel>
          </HStack>
          <HStack w="100%">
            <Switch
              defaultChecked={data?.redo_flag}
              id="redo_flag"
              {...register("redo_flag")}
            />
            <FormLabel htmlFor="redo_flag"> متاح للإعادة redo؟</FormLabel>
          </HStack>
        </VStack>

        <VStack w="50%" gap={4}>
          <Box w="100%">
            <FormLabel w="25%">زمن مؤقت : </FormLabel>
            <MainInput
              label=""
              required={false}
              defaultValues={data.time}
              placeholder=" ادخل زمن الاختبار "
              register={register}
              name="time"
              disabled={!watchTimer}
            />
          </Box>
          <Box w="100%">
            <FormLabel> درجة النجاح : </FormLabel>
            <MainInput
              label=""
              required={true}
              defaultValues={data.success_score}
              placeholder="ادخل درجة النجاح"
              register={register}
              name="success_score"
              error={errors?.success_score?.message}
            />
          </Box>
          <Box w="100%">
            <FormLabel> الدفع المرتبط بالاختبار : </FormLabel>
            <Select
              options={paymentSubjectsOptions}
              isMulti={false}
              onChange={(data) => {
                setValue("payment_subject_id", data?.value);
              }}
              styles={colourStyles}
              placeholder="الدفع المرتبط بالاختبار"
              defaultValue={{
                label: data?.payment_subject?.name,
                value: data?.payment_subject?.id,
              }}
            />
            <p style={{ color: "red" }}>
              {errorslist?.includes("payment_subject_id") && "هذا الحقل مطلوب"}
            </p>
          </Box>
        </VStack>
      </HStack>
      <HStack w="100%" alignItems="flex-start">
        <Box w="100%">
          <FormLabel> درجة صعوبة الامتحان : </FormLabel>
          <Select
            options={difficultyOptions}
            onChange={(data) => setValue("difficulty", data.value)}
            styles={colourStyles}
            placeholder="الاسئلة"
            defaultValue={difficultyOptions?.find(
              (val) => val?.value == data?.difficulty
            )}
            required
          />
          <p>{errorslist?.includes("difficulty") && "هذا الحقل مطلوب"}</p>
        </Box>
        <Box w="100%">
          <FormLabel> اهمية الاختبار :</FormLabel>
          <Select
            options={bookmarkOptions}
            onChange={(data) => {
              setValue("bookmark", data.value);
            }}
            styles={colourStyles}
            placeholder="الاختبار"
            defaultValue={bookmarkOptions?.find(
              (val) => val?.value == data?.bookmark
            )}
          />
          <p>{errorslist?.includes("bookmark") && "هذا الحقل مطلوب"}</p>
        </Box>
      </HStack>
      <HStack w="100%" alignItems="flex-start">
        <Box w="100%">
          <FormLabel> نوع الاختبار : </FormLabel>
          <Select
            options={typeOptions}
            onChange={(data) => {
              setValue("type", data.value);
              if (data?.value == 6) {
                const videosList = videos?.map((data) => {
                  return { value: data.id, label: data.title };
                });
                setVideosOptions(videosList);
              } else {
                setValue("video_id", null);
                setVideosOptions([]);
              }
            }}
            styles={colourStyles}
            placeholder="الاختبار"
            defaultValue={typeOptions?.find((val) => val?.value == data?.type)}
          />
          <p>{errorslist?.includes("type") && "هذا الحقل مطلوب"}</p>
        </Box>

        <HStack w="100%" gap="30px" alignItems="flex-end">
          <Box w="100%">
            <FormLabel>اختر الفيديو : </FormLabel>
            <Select
              key={999}
              isDisabled={watchType != 6}
              options={videosOptions}
              onChange={(data) => {
                setValue("video_id", data?.value);
              }}
              styles={colourStyles}
              noOptionsMessage="الفيديو"
              defaultValue={{
                label: data?.video?.title,
                value: data?.video?.id,
              }}
            />
          </Box>
        </HStack>
      </HStack>

      <HStack w="100%" alignItems="flex-start" gap={4}>
        <Box w="50%">
          <FormLabel> المجموعات : </FormLabel>

          <Select
            options={groupsOptions}
            isMulti
            onChange={(data) => {
              setValue("student_group_ids", data?.map((val) => val?.value));
            }}
            styles={colourStyles}
            placeholder="مجموعات"
            defaultValue={data?.student_groups?.map((val) => {
              return { label: val?.name, value: val?.id };
            })}
            required
          />
        </Box>
        <Box w="50%">
          <FormLabel>الفصل: </FormLabel>
          <Select
            options={chaptersOptions}
            isMulti={false}
            onChange={(data) => {
              setValue("chapter_id", data?.value);
            }}
            styles={colourStyles}
            placeholder="  الفصل"
            defaultValue={{
              label: data?.chapter?.name,
              value: data?.chapter?.id,
            }}
          />
          <p style={{ color: "red" }}>
            {errorslist?.includes("chapter_id") && "هذا الحقل مطلوب"}
          </p>
        </Box>
      </HStack>

      <HStack w="100%" alignItems="flex-start" gap={4}>
        <VStack width="50%" alignItems="flex-start" gap={0}>
          <FormLabel> طريقة الاسئلة : </FormLabel>
          <Select
            options={randomOptions}
            onChange={(data) => setValue("random", data.value)}
            styles={colourStyles}
            placeholder="الاسئلة"
            defaultValue={subTypeOptions?.find(
              (val) => val?.value == data?.random
            )}
          />
          <p style={{ color: "red" }}>
            {errorslist?.includes("random") && "هذا الحقل مطلوب"}
          </p>
        </VStack>
        <VStack width="50%" alignItems="flex-start" gap={0}>
          <FormLabel> نوع الاسئلة : </FormLabel>
          <Select
            options={
              watchQuestionWay
                ? watchQuestionWay == 0
                  ? subTypeOptions?.filter((val) => val?.value != 2)
                  : subTypeOptions
                : []
            }
            onChange={(data) => setValue("sub_type", data.value)}
            styles={colourStyles}
            placeholder="الاسئلة"
            defaultValue={subTypeOptions?.find(
              (val) => val?.value == data?.sub_type
            )}
          />
          <p style={{ color: "red" }}>
            {errorslist?.includes("sub_type") && "هذا الحقل مطلوب"}
          </p>
        </VStack>
        <VStack alignItems="flex-start" gap={0} w="100%">
          <FormLabel w="30%">عدد الأسئلة : </FormLabel>
          <MainInput
            label=""
            defaultValues={data.question_number}
            error={errors?.question_number?.message}
            placeholder=" ادخل عدد الأسئلة "
            register={register}
            name="question_number"
            required={true}
          />
        </VStack>
      </HStack>
      {watchSubType == 1 && (
        <HStack w="50%" alignItems="flex-start">
          <VStack w="100%" alignItems="flex-start">
            <FormLabel>مجموعة الاسئلة : </FormLabel>
            <Select
              options={bucketsOptions}
              isMulti={false}
              onChange={(data) => {
                setValue("buckets[0][bucket_id]", data?.value);
                setValue("buckets[0][no_of_questions]", watchTotalQustions);
              }}
              styles={colourStyles}
              placeholder="مجموعة الاسئلة"
              defaultValue={data?.exam_buckets?.map((val) => {
                return { label: val?.name, value: val?.id };
              })}
            />
            <p style={{ color: "red" }}>
              {errorslist?.includes("buckets") && "هذا الحقل مطلوب"}
            </p>
          </VStack>
        </HStack>
      )}
      {watchSubType == 2 && watchTotalQustions && (
        <HStack w="70%" alignItems="flex-start">
          <VStack w="100%" alignItems="flex-start">
            <HStack justifyContent="space-between" w="100%">
              <FormLabel>مجموعات الاسئلة : </FormLabel>
              <Button
                onClick={() => setFieldsCount((s) => s + 1)}
                isDisabled={
                  totalSelectedQuestions >= watchTotalQustions ? true : false
                }
              >
                أضف فرعا آخر
              </Button>
            </HStack>

            {[...Array(fieldsCount)].map((val, index) => {
              return (
                <HStack w="100%" key={index}>
                  <Box w="45%">
                    <Select
                      options={bucketsOptions}
                      isMulti={false}
                      onChange={(data) => {
                        setValue(
                          `buckets[${index + 1}][bucket_id]`,
                          data?.value
                        );
                      }}
                      styles={colourStyles}
                      placeholder="مجموعات الاسئلة "
                      defaultValue={data?.exam_buckets?.map((val) => {
                        return { label: val?.name, value: val?.id };
                      })}
                    />
                  </Box>

                  <HStack w="60%">
                    <Input
                      defaultValue={
                        data?.exam_buckets?.[index]?.pivot?.no_of_questions
                      }
                      error={errors?.question_number?.message}
                      onChange={(e) => {
                        setValue(
                          `buckets[${index + 1}][no_of_questions]`,
                          e.target.value
                        );
                      }}
                      placeholder="اكتب عدد الاسئلة "
                      name="question_number"
                    />
                  </HStack>
                </HStack>
              );
            })}
            <p style={{ color: "red" }}>
              {errorslist?.includes("buckets") && "هذا الحقل مطلوب"}
            </p>
          </VStack>
        </HStack>
      )}
      {watchSubType == 3 && watchTotalQustions && (
        <HStack w="70%" alignItems="flex-start">
          <VStack w="100%" alignItems="flex-start">
            <HStack justifyContent="space-between" w="100%">
              <FormLabel>تاجات الاسئلة : </FormLabel>
              <Button
                onClick={() => setTagsFieldsCount((s) => s + 1)}
                isDisabled={
                  totalSelectedQuestionsFromTags >= watchTotalQustions ? true : false
                }
              >
                أضف تاجا آخر
              </Button>
            </HStack>

            {[...Array(tagsFieldsCount)].map((val, index) => {
              return (
                <HStack w="100%" key={index}>
                  <Box w="45%">
                    <Select
                      options={tagsOptions}
                      isMulti={false}
                      onChange={(data) => {
                        setValue(
                          `tags[${index}][tag_id]`,
                          data?.value
                        );
                      }}
                      styles={colourStyles}
                      placeholder="تاجات الاسئلة "
                      defaultValue={data?.exam_tags?.[index] ? {
                        label: data?.exam_tags?.[index]?.name,
                        value: data?.exam_tags?.[index]?.id
                      } : null}
                    />
                  </Box>

                  <HStack w="60%">
                    <Input
                      defaultValue={
                        data?.exam_tags?.[index]?.pivot?.no_of_questions
                      }
                      error={errors?.question_number?.message}
                      onChange={(e) => {
                        setValue(
                          `tags[${index}][no_of_questions]`,
                          e.target.value
                        );
                      }}
                      placeholder="اكتب عدد الاسئلة "
                      name="question_number"
                    />
                  </HStack>
                </HStack>
              );
            })}
            <p style={{ color: "red" }}>
              {errorslist?.includes("tags") && "هذا الحقل مطلوب"}
            </p>
          </VStack>
        </HStack>
      )}
    </VStack>
  );
};

export default StepOneForm;
